var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-tooltip',_vm._b({attrs:{"visible":_vm.visible}},'t-tooltip',_vm.$attrs,false),[_vm._t("default",null,{"onMouseEnter":_vm.onMouseEnter,"onMouseLeave":_vm.onMouseLeave})],2)}
var staticRenderFns = []

export { render, staticRenderFns }